<template>
  <div class="Dashboard">
    <div class="Dashboard__Header">
      <Header :title="$t('dashboard.dashboard')" />
    </div>
    <DashboardMetrics />
    <DataTableDisplay :data="dataTable" @click="navigateToItem" />
  </div>
</template>

<script>
import { Header, Card, DataTableDisplay, Icon } from '@/components';

import { getEveryBusiness } from '@/api';

import DashboardMetrics from './DashboardMetrics';

export default {
  name: 'Dashboard',
  data() {
    return {
      dataTable: [],
    };
  },
  components: {
    Icon,
    Header,
    Card,
    DashboardMetrics,
    DataTableDisplay,
  },
  created() {
    getEveryBusiness().then(
      data => {
        this.dataTable = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
  methods: {
    navigateToItem(e, id) {
      this.$router.push({
        name: 'businessDetail',
        params: {
          id,
        },
      });
    }
  }
};
</script>

<style lang="scss">
.Dashboard {
  height: 100%;
  width: 100%;
  &__Header {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
